
import { Component, Mixins } from 'vue-property-decorator';
import { Auth } from 'aws-amplify';
import MessageToastMixin from '@/mixins/MessageToastMixin';
import PhoneSelect from '@/components/form/PhoneSelect.vue';
import { Profile } from '@/api/model';

@Component({
  components: { PhoneSelect },
})
export default class OnboardingSms extends Mixins(MessageToastMixin) {
  steps = {
    UNKNOWN: 'unknown',
    UNVERIFIED: 'unverified',
    DIRECT: 'direct',
  };

  step = this.steps.UNKNOWN;

  phone = '';

  code = '';

  valid = false;

  loading = {
    request: false,
    check: false,
  };

  created() {
    if (this.profile.phone === this.user.attributes.phone_number) {
      this.phone = this.user.attributes.phone_number
        ? this.user.attributes.phone_number
        : '';
    }
  }

  async sendCode() {
    this.loading.request = true;
    await Auth.verifyUserAttribute(this.user, 'phone_number')
      .then(() => {
        this.showSuccess(this.$t('onboarding.sms.code-sent'));
        this.setStep(this.steps.UNVERIFIED);
      })
      .catch((e: Error) => this.showError(e.message))
      .finally(() => {
        this.loading.request = false;
      });
  }

  async checkCode() {
    this.loading.check = true;
    await Auth.verifyUserAttributeSubmit(this.user, 'phone_number', this.code)
      .then(() => {
        this.setMFA();
      })
      .catch((e: Error) => this.showError(e.message))
      .finally(() => {
        this.loading.check = false;
      });
  }

  async setPhoneNumber() {
    await Auth.updateUserAttributes(this.user, { phone_number: this.phone })
      .then(() => {
        const { profile } = this;
        profile.phone = this.phone;
        this.$store.dispatch('profile/saveProfile', profile);
        this.sendCode();
      })
      .catch((e: Error) => this.showError(e.message));
  }

  async setMFA() {
    await Auth.setPreferredMFA(this.user, 'SMS')
      .then(() => {
        this.$emit('finished');
      })
      .catch((e: Error) => this.showError(e.message));
  }

  get user() {
    return this.$store.state.auth.user;
  }

  get profile(): Profile {
    return this.$store.state.profile.profile;
  }

  onValidatePhone(valid: boolean) {
    this.valid = valid;
  }

  setStep(step: string) {
    if (Object.values(this.steps).includes(step)) {
      this.step = step;
    }
  }
}
